module.exports = __webpack_public_path__ + "public/img/wuyut_ldfc3.5027eeab.jpg";